import { Controller } from "@hotwired/stimulus";


export default class extends Controller {
    static values = {
        characterLimit: Number
    };

    initialize() {
        this.textarea = this.element.querySelector("textarea");
        this.characterCounter = this.element.querySelector(".character-counter");
        this.wordCounter = this.element.querySelector(".word-counter");

        if (this.textarea && this.characterCounter && this.wordCounter) {
            this.updateCounters();
            this.textarea.addEventListener("input", this.updateCounters.bind(this));
        }
    }

    updateCounters() {
        const text = this.textarea.value;
        const wordCount = text.trim() ? text.trim().split(/\s+/).length : 0;
        this.wordCounter.textContent = wordCount;

        const characterLimit = this.characterLimitValue - text.length;
        this.characterCounter.textContent = characterLimit;
    }
}